import UsersGallery from 'components/Community/UsersGallery/UsersGallery';
import { withUsersGalleryProps } from 'viewModel/gallery/withUsersGalleryProps';

export default withUsersGalleryProps(UsersGallery);
